export default __webpack_public_path__ + "static/media/Sistemas.de46b575.svg";